import React from "react";
import { motion } from "framer-motion";

const CoreStrengthsSection = () => {
  // Animation variants
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
  };

  return (
    <div className="p-10">
      <section className="relative w-full h-screen overflow-hidden flex items-center justify-center rounded-3xl">
        {/* Background Video */}
        <video
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
          src="https://mhcockpit.com/Media/4%20Aviators/Home/Home-vdo.mp4" // Replace with your video URL
          poster="https://mhcockpit.com/Media/4%20Aviators/Home/cover.jpg"
          autoPlay
          loop
          muted
        ></video>

        {/* Dark overlay for better readability */}
        <div className="absolute inset-0 bg-black/40 z-10"></div>

        {/* Content */}
        <motion.div
          className="relative z-20 text-center px-6 max-w-4xl"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeUp}
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white mb-4">
            Core Strengths That Elevate Your <span className="text-[#FD9F27]">Flight Journey</span>
          </h2>
          <p className="text-white text-sm sm:text-base md:text-lg font-medium">
            Emphasizing the values and systems that make every student soar higher.
          </p>
        </motion.div>
      </section>
    </div>
  );
};

export default CoreStrengthsSection;
